import React from "react";
import { I18n } from "react-redux-i18n";

import Button from "@alboompro/boom-components/general/button";

import { 
  AlertBackdrop, 
  AlertContentWrapper, 
  AlertFooter, 
  AlertMessage, 
  AlertTitle, 
  AlertWrapper 
} from "./styles";

const DiscardChangesAlert = ({ handleCancel, handleDiscard }) => {
  return (
    <AlertWrapper>
      <AlertBackdrop onClick={handleCancel} />
      <AlertContentWrapper>
        <AlertTitle>{I18n.t("editPanel.FAQManager.alertTitle")}</AlertTitle>
        <AlertMessage>{I18n.t("editPanel.FAQManager.alertMessage")}</AlertMessage>
        <AlertFooter>
          <Button
            type="primary"
            style={{
              backgroundColor: "transparent",
              border: "1px solid #bbbbbb"
            }}
            textStyle={{ color: "#525252" }}
            onClick={handleCancel}
          >
            {I18n.t("general.cancel")}
          </Button>
          <Button
            type="primary"
            style={{ backgroundColor: "#ef5d5d" }}
            onClick={handleDiscard}
          >
            {I18n.t("editPanel.FAQManager.discardButton")}
          </Button>
        </AlertFooter>
      </AlertContentWrapper>
    </AlertWrapper>
  );
}

export default DiscardChangesAlert;

   